import React from 'react'

//STYLES
import './CatLink.css'
import { Link } from 'react-router-dom'

export default function CatLink( {category, displayText=false} ) {
  return (
    <li className='cat-link'>
      <Link className='card' to={ category.linkTo }>
        <img src={ category.icon } alt={category.catName} />
        {displayText && <p className="cat-name">{ category.catName }</p>}
      </Link>
    </li>
  )
}
